import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  IconButton,
  Paper,
  Box,
  Typography
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import dayjs from "dayjs";

const DataTable = ({
  rows,
  columns,
  onEdit,
  onDelete,
  page,
  rowsPerPage = 10,
  onPageChange,
  onRowsPerPageChange,
  loading,
  customActions,
  totalRows = 0,
}) => {
  if (loading) {
    return (
      <Box sx={{ p: 2, textAlign: "center" }}>
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  const formatCellValue = (column, value, row) => {
    if (column.format) return column.format(value, row);
    if (column.id.toLowerCase().includes("date") && value) {
      try {
        return dayjs(value).format("YYYY-MM-DD");
      } catch (error) {
        return value;
      }
    }
    return value;
  };

  return (
    <Box sx={{ width: "100%", overflowX: "auto" }}>
      <TableContainer
        component={Paper}
        sx={{
          maxHeight: 600,
          overflowX: "auto",
          border: "1px solid #ddd",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          margin: "20px auto",
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow
              sx={{
                bgcolor: "#124F3E",
                "& .MuiTableCell-root": {
                  color: "white",
                  fontWeight: "bold",
                },
              }}
            >
              {columns.map((column) => (
                <TableCell key={column.id} sx={{ bgcolor: "#124F3E" }}>
                  {column.label}
                </TableCell>
              ))}
              <TableCell sx={{ bgcolor: "#124F3E" }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
                <TableRow key={row.id}>
                  {columns.map((column) => (
                    <TableCell key={column.id}>
                      {formatCellValue(column, row[column.id], row)}
                    </TableCell>
                  ))}
                  <TableCell>
                    {customActions ? (
                      customActions(row)
                    ) : (
                      <>
                        {onEdit && (
                          <IconButton
                            aria-label="edit"
                            color="primary"
                            onClick={() => onEdit(row)}
                          >
                            <EditIcon />
                          </IconButton>
                        )}
                        {onDelete && (
                          <IconButton
                            aria-label="delete"
                            color="secondary"
                            onClick={() => onDelete(row)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        )}
                      </>
                    )}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          position: "sticky",
          bottom: 0,
          backgroundColor: "#fff",
          borderTop: "1px solid #ddd",
        }}
      >
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalRows}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      </Box>
    </Box>
  );
};

export default DataTable;
